if (typeof Shopify === 'undefined') {
    window.Shopify = {};
}

Shopify.theme.mobileMenu = {
    openClassHolderElement: document.body,

    init: function () {
        this.addEvents();
    },

    addEvents: function () {
        [...document.querySelectorAll('.mobilemenu__open')].forEach(el => {
            el.addEventListener('click', this.openMenu.bind(this));
        });
        [...document.querySelectorAll('.mobilemenu__close')].forEach(el => {
            el.addEventListener('click', this.closeMenu.bind(this));
        });
    },

    openMenu: function () {
        if (this.openClassHolderElement.classList.contains('mobile-menu-is-open')) return;
        this.openClassHolderElement.classList.add('mobile-menu-is-open');
    },

    closeMenu: function () {
        this.openClassHolderElement.classList.remove('mobile-menu-is-open');
    }
};

(() => {
    Shopify.theme.mobileMenu.init();
    document.body.classList.add('js-menu-opening-enabled');
})();
